import axios, { AxiosRequestConfig } from 'axios';
import { useToken } from '../contexts/tokenContext';
import { State } from '../entities/State';

export const useUpdateState = () => {
	const token = useToken();
	return async (stateId: number, form: any): Promise<State | null> => {
		try {
			if (!token?.accessToken) {
				return null;
			}

			delete form.id;

			const params: AxiosRequestConfig = {
				method: 'PATCH',
				url: `/states/${stateId}`,
				data: form,
				withCredentials: true,
			};
			const result = await axios.request(params);
			return result.data;
		} catch (error) {
			throw error;
		}
	};
};
